import * as service from './service';

export const featureFlagsStore = {
  service,
};
